export enum LayoutMode {
    DESKTOP = "desktop",
    MOBILE = "mobile",
}
export interface LayoutProps {
    layoutMode: LayoutMode
}